<div class="container">
  <p>This user has not been set up with access to the system.  Please contact a system administrator.</p>
</div>